module.exports = __webpack_public_path__ + "img/product2880p12.bfd5cdf2.png";